import { useMemo } from 'react';
import { canSeeAlerts, decodePerms, hasTreasurerBox, inMinyanScope, levelOf, type Level, type PageKey, type Perms } from '@shared/permissions.ts';
import { useAuth } from './AuthProvider';

/**
 * Cosmetic permission checks for the UI (menus, buttons, routes). The real enforcement is in
 * firestore.rules and the callables — never rely on this alone.
 */
export function usePermissions() {
  const { claims } = useAuth();
  return useMemo(() => {
    const active = claims?.a === 1;
    const perms: Perms = decodePerms(active ? claims?.p : '');
    return {
      active,
      perms,
      level: (page: PageKey): Level => levelOf(claims, page),
      canRead: (page: PageKey) => levelOf(claims, page) >= 1,
      canWrite: (page: PageKey) => levelOf(claims, page) === 2,
      pii: active && claims?.x === 1,
      inScope: (minyanId: string) => inMinyanScope(claims, minyanId),
      allMinyanim: Boolean(claims?.m?.includes('*')),
      /** alerts center + bell + "waiting" alert counts — financial readers only */
      seeAlerts: canSeeAlerts(claims),
      /** "קופת גזבר" — only the users marked on their card (claim t, owner 2026-10-17) */
      treasurer: hasTreasurerBox(claims),
    };
  }, [claims]);
}
